import { Injectable } from '@angular/core';
import "cordova-plugin-purchase"
import { AuthenticationService } from './authentication.service';
import { Platform } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PurchaseService {
    store?: CdvPurchase.Store;

    IAPTIC_CONFIG: CdvPurchase.IapticConfig = {
        appName: '',
        apiKey: '',
    }

    readonly BRANCHE_ID_APPLE = 'com.begaym.branche';
    readonly GEEK_ID_APPLE = 'com.begaym.geek';

    readonly BRANCHE_ID_GOOGLE = 'com.begaym.branche';
    readonly GEEK_ID_GOOGLE = 'com.begaym.geek';

    public loading = true;

    userRequestedPurchase = false;

    /**
     * 
     */
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService, 
        private platform:Platform
    ) {
    }

    /**
     * 
     */
    async startup() {

        if (this.platform.is('capacitor')) {
            this.store = CdvPurchase.store;

            if (!this.store) {
                // console.error('Store plugin not available.');
                return;
            }

            // this.store.verbosity = CdvPurchase.LogLevel.DEBUG;
            // this.store.minTimeBetweenUpdates = 1000;
            
            this.store.register([
                { id: this.BRANCHE_ID_APPLE, type: CdvPurchase.ProductType.PAID_SUBSCRIPTION, platform: CdvPurchase.Platform.APPLE_APPSTORE },
                { id: this.GEEK_ID_APPLE, type: CdvPurchase.ProductType.PAID_SUBSCRIPTION, platform: CdvPurchase.Platform.APPLE_APPSTORE },
                { id: this.BRANCHE_ID_APPLE, type: CdvPurchase.ProductType.PAID_SUBSCRIPTION, platform: CdvPurchase.Platform.GOOGLE_PLAY },
                { id: this.GEEK_ID_APPLE, type: CdvPurchase.ProductType.PAID_SUBSCRIPTION, platform: CdvPurchase.Platform.GOOGLE_PLAY }
            ]);

            this.store.when().approved(async (transaction: CdvPurchase.Transaction) => {
                this.loading = true;
                await transaction.verify().then(() => {});
                this.loading = false;
            });

            this.store.when().verified(async (receipt: CdvPurchase.VerifiedReceipt) => {
                // console.log('✅ Receipt verified:', this.store.verifiedReceipts, this.store.verifiedPurchases);
                this.loading = true;
                await receipt.finish().then(() => {});
                this.loading = false;
            });

            this.store.when().unverified(async (unverified: CdvPurchase.UnverifiedReceipt) => {
                this.loading = true;
                await unverified.receipt.finish();
                this.loading = false;
                // console.log('✅ Receipt finished:', this.store.verifiedReceipts, this.store.verifiedPurchases);
            });

            this.store.when().productUpdated((product: CdvPurchase.Product) => {
                // console.log('✅ Product updated:', product, product.owned);
            });

            let iapInitialReceiptUpdated = false;
            this.store.when().receiptUpdated((receipt: CdvPurchase.Receipt) => {
                if (!iapInitialReceiptUpdated) {
                    this.loading = true;
                    receipt?.verify().then(() => {this.loading = false;});
                    iapInitialReceiptUpdated=true;
                }
            });

            this.store.when().finished((transaction: CdvPurchase.Transaction) => {
                // console.log('✅ Transaction finished:', transaction, this.store.verifiedReceipts, this.store.verifiedPurchases);
                this.loading = true;
                this.authenticationService.refreshToken().subscribe(() => {
                    this.authenticationService.loadMe().subscribe(() => {
                        if (this.authenticationService.isSubscribed && this.userRequestedPurchase) {
                            this.userRequestedPurchase = false;
                            this.router.navigate(['/', 'abonnement-confirmation'])
                        }
                        this.loading = false;
                    });
                });
            });

            this.store.error((err: any) => {
                this.userRequestedPurchase = false;
                this.loading = false;
            });

            if (this.authenticationService.meValue) {
                this.store.applicationUsername = this.authenticationService.meValue['@id'].replace('/users/', '');
                const rawToken = this.authenticationService.rawToken;
                this.store.validator = { url: `${environment.apiUrl}/iap-validate`, headers: { authorization: `Bearer ${rawToken.token}` } };
                // this.store.validator = 'https://validator.iaptic.com/v3/validate?appName=com.begaym.app&apiKey=8a492943-400f-4395-b636-fb4acc64e39c';
                await this.store.initialize([{
                    platform: CdvPurchase.Platform.APPLE_APPSTORE,
                    options: {
                        needAppReceipt: true,
                    }
                }, {
                    platform: CdvPurchase.Platform.GOOGLE_PLAY
                }]);
            }

            this.store.ready(() => {
                this.loading = false;
                
                setInterval(async () => {
                    await this.store.update();
                }, 1000 * 60 * 60 * 12);

            });
        } else {
            this.loading = false;
        }
    }

    async update() {
        if (this.authenticationService.meValue) {
            this.store.applicationUsername = this.authenticationService.meValue['@id'].replace('/users/', '');
            const rawToken = this.authenticationService.rawToken;
            this.store.validator = { url: `${environment.apiUrl}/iap-validate`, headers: { authorization: `Bearer ${rawToken.token}` } };
            // this.store.validator = 'https://validator.iaptic.com/v3/validate?appName=com.begaym.app&apiKey=8a492943-400f-4395-b636-fb4acc64e39c';
            await this.store.update();
        }
    }

    /**
     * 
     */
    public async purchase(tier: string, up:boolean = true, applicationUsername:string = '') {
        
        let productId;
        let product:CdvPurchase.Product;
        let offer:CdvPurchase.Offer | undefined;

        this.store.applicationUsername = applicationUsername;

        if (this.platform.is('ios')) {
            productId = tier === 'branche'  ? this.BRANCHE_ID_APPLE : this.GEEK_ID_APPLE;
        } else {
            productId = tier === 'branche'  ? this.BRANCHE_ID_GOOGLE : this.GEEK_ID_GOOGLE;
        }
        product = this.store.get(productId);

        if (!product || !product.canPurchase) {
            // console.warn(`Product ${productId} cannot be purchased right now.`);
            return;
        }

        offer = product.getOffer();
        
        if (!offer) {
            // console.error('No offer available for product:', productId);
            return;
        }

        this.userRequestedPurchase = true;
        this.loading = true;

        let oldPurchaseToken;

        if (this.platform.is('android')) {
            for (let receipt of this.store.verifiedReceipts) {
                if (receipt.latestReceipt) {
                    if (receipt.collection.some(entry => entry.isExpired === false)) {
                        if ((up && receipt.id == this.BRANCHE_ID_GOOGLE) || (!up && receipt.id == this.GEEK_ID_GOOGLE)) {
                            oldPurchaseToken = (receipt.sourceReceipt as CdvPurchase.GooglePlay.Receipt).purchaseToken
                        }
                    }
                }
            }
        }

        let googlePlayData: CdvPurchase.GooglePlay.AdditionalData = {
            accountId: this.store.applicationUsername as string,
            profileId: this.store.applicationUsername as string,
            offerToken: (offer as CdvPurchase.GooglePlay.SubscriptionOffer).token
        };

        if (oldPurchaseToken) {
            googlePlayData.oldPurchaseToken = oldPurchaseToken;
            googlePlayData.replacementMode = up ? CdvPurchase.GooglePlay.ReplacementMode.CHARGE_PRORATED_PRICE : CdvPurchase.GooglePlay.ReplacementMode.DEFERRED;
        }

        // console.log({
        //     applicationUsername: this.store.applicationUsername as string,
        //     googlePlay: googlePlayData
        // });
        return offer.order({
            applicationUsername: this.store.applicationUsername as string,
            googlePlay: googlePlayData
        }).then(() => {
            this.loading = false;
        }).catch((err: any) => {
            this.loading = false;
            // console.error('Failed to order product:', err);
        });
    }

    /**
     * 
     */
    public restore() {
        this.store.restorePurchases();
    }

    /**
     * 
     */
    public manageSubscriptions() {
        this.store.manageSubscriptions();
    }
}
